/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FloorplanDto } from '../../models/floorplan-dto';
import { UpdateFloorplanDto } from '../../models/update-floorplan-dto';

export interface FloorplanControllerUpdate$Params {
  id: string;
  clientWorkspaceId: string;
      body: UpdateFloorplanDto
}

export function floorplanControllerUpdate(http: HttpClient, rootUrl: string, params: FloorplanControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorplanDto>> {
  const rb = new RequestBuilder(rootUrl, floorplanControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FloorplanDto>;
    })
  );
}

floorplanControllerUpdate.PATH = '/api/floorplan/{clientWorkspaceId}/{id}';
